import PortfolioScore from './widgets/PortfolioScore'
import PortfolioRiskDistribution from './widgets/PortfolioRiskDistribution'
import PortfolioRiskHistory from './widgets/PortfolioRiskHistory'
import PointsOfAttention from './widgets/PointsOfAttention'
import { useMonitorShowList } from 'services/queries'

const Summary = ({
  listId,
  handlePortfolioInsightsFilters,
}: {
  listId: string
  handlePortfolioInsightsFilters: (category: string, key: string | []) => void
}) => {
  const { data: showListsData, isLoading: isShowListsLoading } = useMonitorShowList()
  return (
    <>
      <PortfolioScore listId={listId} />
      <PortfolioRiskDistribution
        listId={listId}
        handlePortfolioInsightsFilters={handlePortfolioInsightsFilters}
        showListsData={showListsData}
        isLoading={isShowListsLoading}
      />
      <PortfolioRiskHistory listId={listId} />
      <PointsOfAttention
        listId={listId}
        handlePortfolioInsightsFilters={handlePortfolioInsightsFilters}
      />
    </>
  )
}

export default Summary
